import { MessageDescriptor } from 'react-intl';
import {
    DAYS_COUNT_BEFORE_ANONYMIZATION_MAX,
    DAYS_COUNT_BEFORE_ANONYMIZATION_MIN,
} from '../../../constants/common.constants';
import { DAYS_COUNT_BEFORE_ANONYMIZATION_ERROR_MESSAGE } from '../../../constants/validation-errors';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { ANONYMIZATION_DATA_UPDATED_TEXT } from '../account-admin.text';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';

class DataAnonymizationFormVM extends BaseAccountAdminSettingViewModel {
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);
    }

    public getDataAnonymizationEnabledValidationError = (): string | null => {
        return (
            this.entity.additionalData as number < DAYS_COUNT_BEFORE_ANONYMIZATION_MIN ||
            this.entity.additionalData as number > DAYS_COUNT_BEFORE_ANONYMIZATION_MAX
        )
            ? DAYS_COUNT_BEFORE_ANONYMIZATION_ERROR_MESSAGE
            : null;
    };

    public get notificationMessage(): MessageDescriptor {
        return ANONYMIZATION_DATA_UPDATED_TEXT;
    }

    public async apiCall(): Promise<void> {
        await this.accountAdminDAO.updateDataAnonymization({
            ...this.entity.getCommonAPIPayload(),
            anonymizationEnabled: this.entity.enabled,
            daysCountBeforeAnonymization: this.entity.additionalData as number,
        });
    }

    protected shouldInterruptSubmit(): boolean {
        return this.saving || !!this.getDataAnonymizationEnabledValidationError();
    }
}

export { DataAnonymizationFormVM };
